import axios from "axios";
import { API_BASE } from "../config/constants";

export const authorizationResourceMembership = axios.create({
  baseURL: `${API_BASE}/api/v1/authorization/membership`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const authorizationResourceExhibitor = axios.create({
  baseURL: `${API_BASE}/api/v1/authorization/exhibitor`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const paymentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/payment`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const pageSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/settings`,
});

export const currentUserResource = axios.create({
  baseURL: `${API_BASE}/api/v1/currentUser`,
});

export const currentGroupsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/currentGroups`,
});

export const openPaymentsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/openPayments`,
});

export const usersResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users`,
});

export const usersImportResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/import`,
});

export const usersGroupsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/groups`,
});

export const submissionsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const submissionReviewResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/review`,
});

export const submissionMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/submission/mail`,
});

export const attachmentResource = axios.create({
  baseURL: `${API_BASE}/api/v1/attachments`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: "ApiKey 1d952c05-474f-4006-978b-c4d871d9ae4f",
  },
});

export const documentsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/user-documents`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const documentsMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/documents/mail`,
});

export const surveyResource = axios.create({
  baseURL: `${API_BASE}/api/v1/user-survey`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const surveyVoteResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/survey/vote`,
});

export const surveyResetResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/survey/reset`,
});

export const surveyMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/survey/mail`,
});

export const switchPaymentStateResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/switchPaymentState`,
});

export const payMembershipFeesResource = axios.create({
  baseURL: `${API_BASE}/api/v1/users/payMembershipFees`,
});

export const pageTypeResource = axios.create({
  baseURL: `${API_BASE}/api/v1/pageType`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const verificationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const mcaptchaSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha/settings`,
});

export const exhibitorLoginResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/login`,
});

export const exhibitorByTokenResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/token`,
});

export const exhibitorPersonResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/persons`,
});

export const exhibitorPayResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/pay`,
});

export const exhibitorMailResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/mail`,
});

export const exhibitorVirtualExhibitionResource = axios.create({
  baseURL: `${API_BASE}/api/v1/exhibitors/virtual-exhibition`,
});

export const boothResource = axios.create({
  baseURL: `${API_BASE}/api/v1/booths`,
  headers: {
    "Content-Type": "application/json",
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});
